import { createFileRoute } from "@tanstack/react-router";

import AgentTurnLimitAdmin from "@/components/AgentTurnLimitAdmin";

// Generated to match `src/app/admin/agent-turn-limit/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/agent-turn-limit")({
  component: AgentTurnLimitAdmin,
});
